/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_NavInputs */

const id_api_keys_nav = /** @type {(inputs: Api_Keys_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API`)
};

const en_api_keys_nav = /** @type {(inputs: Api_Keys_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API keys`)
};

/**
* | output |
* | --- |
* | "API keys" |
*
* @param {Api_Keys_NavInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const api_keys_nav = /** @type {((inputs?: Api_Keys_NavInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_NavInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_keys_nav(inputs)
	return id_api_keys_nav(inputs)
});